import { render, staticRenderFns } from "./OrganizationBrand.vue?vue&type=template&id=70d545ec&scoped=true"
import script from "./OrganizationBrand.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationBrand.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationBrand.vue?vue&type=style&index=0&id=70d545ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d545ec",
  null
  
)

export default component.exports